var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-text-box-check",
      show: _vm.dialog,
      maxWidth: "40%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _vm.renderComponent
                          ? _c("sys-select-occurrence-status", {
                              attrs: {
                                model: _vm.model.occurrence_status_id,
                                error: _vm.errors.length > 0,
                                errors: _vm.errors.occurrence_status_id,
                                label: "Status",
                                filter: _vm.filter,
                                disabled: _vm.disableValidation,
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(
                                    _vm.model,
                                    "occurrence_status_id",
                                    $event
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            "error-messages": _vm.errors.justification,
                            label: "Justificativa",
                            counter: 255,
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                          },
                          model: {
                            value: _vm.model.justification,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "justification", $$v)
                            },
                            expression: "model.justification",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }